module.exports = __webpack_public_path__ + "static/media/brahem1.f7360c13.webp";